<script setup>  
  import { ref, onMounted, getCurrentInstance } from 'vue';
  import { usePageLoadingStore } from '../../../../../stores/pageLoading';
  import { useRoute, useRouter } from 'vue-router';
  import adminJobfairStateService from '../../../services/jobfair/adminJobfairStateService';
  import JobFairResumeDetailModal from '../../../../user/components/modal/jobFair/JobFairResumeDetailModal.vue';
  import JobFairJobNoticeDetailModal from '../../../../user/components/modal/jobFair/JobFairJobNoticeDetailModal.vue';
  import mypageJobFairService from '../../../../user/services/mypage/jobFair/mypageJobFairService';

  const route = useRoute();
  const router = useRouter();
  const loadingStore = usePageLoadingStore();
  const { $gbNameKR, $toast, $number, $pageListBoardNo, $yyyymmddHHmmss, alert, confirm } = getCurrentInstance().appContext.config.globalProperties;
  const currentPage = ref(1);
  const pageSize = ref(10);
  const totalPages = ref(0);
  const totalCount = ref(0);
  const list = ref([]);

  const resumeModal = ref(null);
  const jobNoticeModal = ref(null);

  const pageSizeGroup = ref([
    { label:'10개씩 보기', value: '10' },
    { label:'30개씩 보기', value: '30' },
    { label:'50개씩 보기', value: '50' },
    { label:'100개씩 보기', value: '100' },
  ]);
  
  // 페이지 선택
  const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
  }

  // 검색조건 - 페이지 사이즈 변경. 10,30,50,100
  const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
  }

  const retrieveList = () => {
    const paramObj = {
      pageNumber: currentPage.value,
      size: pageSize.value,
      corpId: route.params.id,
    };

    loadingStore.loading = true;
    adminJobfairStateService.retrieveAllInterviewProposalEntryListPagingByCorpId(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if (res.data.code.toLowerCase() === "success") {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      })
      .catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
      });
  }

  const onClickResume = async (resumeId, delYn) => {
    if(delYn === 'Y') {
      alert("삭제된 이력서입니다.");
      return;
    }

    await resumeModal.value.show({
      resumeId,
    });
  }

  const onClickJobNotice = async (jobNoticeSeq, corpId) => {
    await jobNoticeModal.value.show({
      jobNoticeSeq,
      corpId,
    });
  }
  
  // 보낸 면접제안 상태변경
  const onClickIntvPropState = async (resumeId, jobNoticeSeq, stateGb) => {
    let ok, messageContent, okButtonText;
    if(stateGb === '04') {
      messageContent = ["제안을 취소 하시겠습니까?", "'제안취소'로 상태가 변경됩니다."];
      okButtonText = "제안취소";
    } else if(stateGb === '05') {
      messageContent = ["최종합격 처리하시겠습니까?", "'최종합격'으로 상태가 변경됩니다."];
      okButtonText = "최종 합격";
    } else if(stateGb === '06') {
      messageContent = ["최종불합격 처리하시겠습니까?", "'최종불합격'으로 상태가 변경됩니다."];
      okButtonText = "최종 불합격";
    }

    ok = await confirm(messageContent, okButtonText);
    if(ok) {
      const paramObj = {
        resumeId,
        jobNoticeSeq,
        intvPropStateGb: stateGb,
      };

      mypageJobFairService.updateIntvPropStateGb(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            alert(["변경하였습니다."]);
            retrieveList();
          } else {
            alert(["변경을 실패하였습니다."]);
          }
        })
        .catch( (res) =>  {
          loadingStore.loading = false;
          alert(["변경을 실패하였습니다."]);
        });
    }
  }

  const openDetailInNewTab = (linkName, id = {}) => {
    const url = router.resolve({
      name: linkName,
      params: { id },
    }).href;

    window.open(url, '_blank');
  }

  onMounted(() => {
    retrieveList();
  })

</script>
<template>
  <div class="list-top">
    <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
    <div>
      <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
    </div>
  </div>
  <div class="table-form">
    <table class="horizontal">
      <tr>
        <th>NO</th>
        <th>회원코드</th>
        <th>이름</th>
        <th>아이디</th>
        <th>이력서 제목</th>
        <th>관심 카테고리</th>
        <th>전공계열(주전공)</th>
        <th>면접제안 공고 제목</th>
        <th>마스터</th>
        <th>제안일</th>
        <th>상태</th>
        <th>상태 변경</th>
      </tr>
      <tr v-for="intvOffer in list">
        <td>{{ intvOffer.boardNo }}</td>
        <td>{{ intvOffer.userCd }}</td>
        <td class="clickable blue">
          <span @click="openDetailInNewTab('MemberDetail', intvOffer.userCd)">{{ intvOffer.userName }}</span>
        </td>
        <td>{{ intvOffer.userLoginId }}</td>
        <td class="text-overflow long-overflow">
          <span class="file" v-if="intvOffer.fileYn === 'Y'" v-for="resumeAttaches in intvOffer.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
            {{ resumeAttaches.fileName }}
          </span>
          <span class="clickable blue" v-else @click="onClickResume(intvOffer.resumeId, intvOffer.delYn)">
            {{ intvOffer.title }}
          </span>
        </td>
        <td>{{ intvOffer.interests }}</td>
        <td>{{ $gbNameKR("MAJOR_GB", intvOffer.majorGb) }}</td>
        <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(intvOffer.jobNoticeSeq, intvOffer.corpId)">{{ intvOffer.jobName }}</td>
        <td class="clickable blue">
          <span @click="openDetailInNewTab('MemberDetail', intvOffer.masterUserId)">{{ intvOffer.masterUserName }}</span>
        </td>
        <td>{{ $yyyymmddHHmmss(intvOffer.createDate) }}</td>
        <td>
          <span v-if="intvOffer.intvPropStateGb === '01'">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',intvOffer.intvPropStateGb) }}</span>
          <span v-else-if="intvOffer.intvPropStateGb === '02' || intvOffer.intvPropStateGb === '05'" class="blue">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',intvOffer.intvPropStateGb) }}</span>
          <span v-else-if="intvOffer.intvPropStateGb === '03' || intvOffer.intvPropStateGb === '06'" class="red">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',intvOffer.intvPropStateGb) }}</span>
          <span v-else class="gray">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',intvOffer.intvPropStateGb) }}</span>
        </td>
        <td>
          <div v-if="intvOffer.intvPropStateGb === '01'">
            <KSATextButton text="제안취소" @click="onClickIntvPropState(intvOffer.resumeId, intvOffer.jobNoticeSeq, '04')" class="clickable black"></KSATextButton>
          </div>
          <div v-else-if="intvOffer.intvPropStateGb === '02'">
            <KSATextButton text="최종합격" @click="onClickIntvPropState(intvOffer.resumeId, intvOffer.jobNoticeSeq, '05')" class="clickable black"></KSATextButton>
            &nbsp;
            <KSATextButton text="최종불합격" @click="onClickIntvPropState(intvOffer.resumeId, intvOffer.jobNoticeSeq, '06')" class="clickable black"></KSATextButton>
          </div>
          <div v-else-if="intvOffer.intvPropStateGb === '05'">
            <KSATextButton text="최종불합격" @click="onClickIntvPropState(intvOffer.resumeId, intvOffer.jobNoticeSeq, '06')" class="clickable black"></KSATextButton>
          </div>
          <div v-else-if="intvOffer.intvPropStateGb === '06'">
            <KSATextButton text="최종합격" @click="onClickIntvPropState(intvOffer.resumeId, intvOffer.jobNoticeSeq, '05')" class="clickable black"></KSATextButton>
          </div>
          <div v-else>-</div>
        </td>
      </tr>
    </table>
    <div class="result-none" v-if="list.length === 0">
      보낸 면접제안 내역이 없습니다.
    </div>
  </div>
  <Paginate
    v-if="list.length > 0"
    v-model="currentPage"
    :page-count="totalPages"
    :click-handler="onSelectPage"
  />
  <JobFairResumeDetailModal ref="resumeModal" /> <!-- 이력서 보기-->
  <JobFairJobNoticeDetailModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
</template>

<style scoped>
</style>